'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './manageusers.routes';

export class ManageusersComponent {
  /*@ngInject*/
  constructor($scope, $http, userService, baseConfigService, fetch, $state) {
    // Variables 
    this.$scope = $scope;
    this.$http = $http;
    this.$state = $state;
    this.fetch = fetch;

    // Services 
    this.userService = userService;
    this.baseConfigService = baseConfigService;
    $scope.baseUrl = baseConfigService.getBaseURL();

    this.$scope.updateUserP = {};
    this.$scope.updateUser = {};
    this.$scope.delUser = {};
    this.$scope.newUser = {};
    this.$scope.organizations = []; // Populate this with your jurisdictions
    this.$scope.sponsors = []; // Will be populated from database


    /**
 * Get list of jurisdictions
 */
    $scope.getJurisdictionList = function () {
      fetch.getAllItems('api/data/jurisdictions/list')
        .then(response => {

          $scope.organizations = response.data;
          console.log($scope.organizations);
          // $scope.jurisdiction = response.data[0].jurisdiction;
          // $scope.getStationAreaList($scope.jurisdiction);
        })
        .catch(err => {
          console.log(err);
        })
    }

    /**
     * Get list of sponsors from database
     */
    $scope.getSponsorList = function () {
      fetch.getAllItems('api/data/sponsors/list')
        .then(response => {
          $scope.sponsors = response.data;
          console.log('Sponsors loaded:', $scope.sponsors);
        })
        .catch(err => {
          console.log('Error loading sponsors:', err);
        })
    }



    // Function to save the selected jurisdictions
    $scope.saveSelection = function () {
      $scope.saving = true;
      // Collect selected jurisdictions
      const selectedJurisdictions = $scope.organizations
        .filter(item => item.selected) // Filter selected items
        .map(item => item.jurisdiction_id); // Map to jurisdiction_ids

      // Prepare the data to send to the API
      const data = {
        userId: $scope.updateUser.id, // Assuming userId is part of updateUser
        jurisdictionIds: selectedJurisdictions
      };
      console.log(data);

      // Send the data to the API using promises
      fetch.updateItem(`api/data/users/save-user-jurisdictions`, data)
        .then(function (response) {
          console.log('Jurisdictions saved successfully:', response.data);
          $scope.saving = false;
          $('#updateUsersModal').modal('toggle');
        })
        .catch(function (error) {
          console.error('Error saving jurisdictions:', error);
          $scope.saving = false;
        });
    };

    // Function to save the selected sponsors (separate from jurisdictions)
    $scope.saveSponsorSelection = function () {
      $scope.savingSponsors = true;
      // Collect selected sponsor IDs
      const selectedSponsors = $scope.sponsors
        .filter(item => item.selected) // Filter selected items
        .map(item => item.sponsor_id); // Map to sponsor_ids (UUIDs)

      // Prepare the data to send to the API
      const data = {
        userId: $scope.updateUser.id,
        sponsorIds: selectedSponsors
      };
      console.log('Saving sponsors:', data);

      // Send the data to the API
      fetch.updateItem(`api/data/users/save-user-sponsors`, data)
        .then(function (response) {
          console.log('Sponsors saved successfully:', response.data);
          $scope.savingSponsors = false;
          $('#updateUsersModal').modal('toggle');
        })
        .catch(function (error) {
          console.error('Error saving sponsors:', error);
          $scope.savingSponsors = false;
        });
    };

    $scope.cancelSelection = function () {
      // Logic to handle cancel action
    };

    $scope.escapeCSVValue = function(value) {
      if (value === null || typeof value === 'undefined') {
          return ''; // Represent null/undefined as empty string
      }
      // Handle boolean specifically for 'Active' column
      if (typeof value === 'boolean') {
          return value ? 'Yes' : 'No';
      }
      
      value = String(value); // Convert other types to string
  
      // Check if the value contains comma, double quote, or newline/carriage return
      if (value.includes(',') || value.includes('"') || value.includes('\n') || value.includes('\r')) {
          // Escape double quotes by doubling them and wrap the whole value in double quotes
          return '"' + value.replace(/"/g, '""') + '"';
      }
      return value; // Return as is if no special characters
  }
  
      // Export to CSV 
      $scope.exportToCSV = function () {
        // Get the data from the filtered collection
        const data = $scope.filteredCollection
  
        const headers = ['First', 'Last', 'Jurisdiction', 'Email', 'Role', 'Active'];
        const keys = ['firstname', 'lastname', 'organization', 'email', 'role', 'active'];
  
         // Create a CSV string using a simple loop
         let csv = '';
        // Add header row
        csv += headers.join(',') + '\n';
  
       // Add header row
       csv += headers.join(',') + '\n';
  
       // Add data rows by mapping object properties
       data.forEach(row => {
         const rowValues = keys.map(key => $scope.escapeCSVValue(row[key])); // Map keys to values and escape them
         csv += rowValues.join(',') + '\n';
       });
  
        // Prompt the user for a filename
        const filename = prompt("Enter a filename for the CSV file:", "toc_users.csv");
  
        // If the user cancels, do nothing
        if (filename === null) {
          return;
        }
  
        // Create a hidden link element
        const link = document.createElement('a');
        link.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csv);
        link.download = filename;
  
        // Trigger a click event on the link to download the CSV file
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      };





  }

  $onInit() {
    // this.$scope.loading = true;
    this.userService.getCurrentUser()
      .then(response => {

        this.$scope.currentUser = response.data;
        this.getAllUsers();
        this.$scope.getJurisdictionList();
        this.$scope.getSponsorList();
      })
      .catch(err => {
        console.log(err);
        if (err.status === 403) {
          this.$state.go('login');
        }
      })

  }



  /**
   * Gets a list of all application users
   * Service: userService (app/components/services/users)
   * @param N/A
   */
  getAllUsers() {
    var adminBaseURL = this.baseConfigService.getAdminBaseURL();

    this.userService.getAllUsers()
      .then(users => {
        this.$scope.rowCollection = users.data;

        const data = users.data;
        console.log(data);

        var thisIsValid = this.$scope.thisIsValid;


        //   this.$scope.hot = new Handsontable(container, {
        //     data,
        //     colHeaders: true,
        //     allowInsertRow: true,
        //     manualColumnResize: true,
        //     height: 'auto',
        //     stretchH: "all",
        //     width: "100%",
        //     autoWrapRow: true,
        //     rowHeaders: true,
        //     manualColumnFreeze: true,
        //     manualColumnMove: true,
        //     manualColumnResize: true,
        //     hiddenColumns: {
        //       // columns: [2, 4, 6],
        //       indicators: true,
        //     },
        //     filters: true,
        //     contextMenu: true,
        //     dropdownMenu: [
        //       "filter_by_condition",
        //       "filter_by_value",
        //       "filter_action_bar",
        //     ],
        //     hiddenColumns: { // enable hiding columns
        //       indicators: true,
        //     },
        //     manualColumnMove: true, // enable moving columns
        //     manualColumnFreeze: true, // enable freezing columns
        //     manualColumnResize: true, // enable resizing columns
        //     multiColumnSorting: {
        //       indicator: true,
        //     },
        //     colHeaders: [
        //       "ID",
        //       "First Name",
        //       "Last Name",
        //       "Title",
        //       "Phone",
        //       "Email",
        //       "Organization",
        //       "Role",
        //       "Permissions",
        //       "TOC App",
        //       "Active"],
        //     columns: [
        //       { data: 'id' },
        //       { data: 'firstname' },
        //       { data: 'lastname' },
        //       { data: 'title' },
        //       { data: 'phone' },
        //       { data: 'email' },
        //       { data: 'organization' },
        //       { data: 'role',
        //       type: "dropdown",
        //         source: [
        //           "Administrator",
        //           "User",
        //           "Consultant",
        //           "CTA"
        //         ],
        //         strict: true 
        //       },
        //       { data: 'permissions',
        //       type: "dropdown",
        //         source: [
        //           "Viewer",
        //           "Editor"
        //         ],
        //         strict: true 
        //       },
        //   { data: 'toc_app',
        //   type: "checkbox",
        //   className: "htCenter"
        // },
        //   { data: 'active',
        //   type: "checkbox",
        //   className: "htCenter"
        // },
        //     ],
        //     minSpareRows: 1,
        //     licenseKey: 'non-commercial-and-evaluation',
        //     afterValidate(isValid, value, row, prop, source) {
        //       thisIsValid = isValid;
        //     },
        //   });

        //   var hot = this.$scope.hot;
        // var http = this.$http;

        // hot.addHook("afterChange", function(changes, source) {
        //   var updateData = [];
        //   changes.forEach(([row]) => {
        //     var handsonUpdate = hot.getDataAtRow(row);
        //     updateData.push({
        //       _id: handsonUpdate[0],
        //       firstname: handsonUpdate[1],
        //       lastname: handsonUpdate[2],
        //       title: handsonUpdate[3],
        //       phone: handsonUpdate[4],
        //       email: handsonUpdate[5],
        //       organization: handsonUpdate[6],
        //       role: handsonUpdate[7],
        //       permissions: handsonUpdate[8],
        //       toc_app: handsonUpdate[9],
        //       active: handsonUpdate[10],
        //     });

        //     if(typeof thisIsValid === "undefined") {
        //       console.log("its undefined");
        //       http
        //         .post(`${adminBaseURL}/users/update`, updateData)
        //         .then((responseReport) => {
        //         })
        //         .catch((err) => {
        //           console.log(err);
        //         });
        //     } else if(!thisIsValid) {
        //       console.log("its not valid");
        //     } else {
        //       // update data in database
        //       http
        //         .post(`${adminBaseURL}/users/update`, updateData)
        //         .then((responseReport) => {
        //         })
        //         .catch((err) => {
        //           console.log(err);
        //         });
        //     }

        //   });

        // });

      })
      .catch(err => {
        console.log(err);
      })
  }

  /**
   * Get a single user
   * Service: userService (app/components/services/users)
   * @param {*} id | id of user 
   */
  getUser(id) {
    this.userService.getUser(id)
      .then(user => {
        console.log(user)
      })
      .catch(err => {
        console.log(err);
      })
  }



    
  /**
 * Updates a single user
 * Service: userService (app/components/services/users)
 * @param {*} id (id of user to be updated)
 */

  updateModal(data) {
    this.$scope.updateUser = data;
    console.log(data);

    // Fetch the user's jurisdictions
    this.fetch.getAllItems(`api/data/users/get-users-jurisdictions/${data.id}`)
      .then(response => {
        console.log('User jurisdictions:', response.data);

        // Extract jurisdiction IDs from the response
        const jurisdictionIds = response.data.jurisdictionIds; // Adjust based on your API response structure

        // Update $scope.organizations to set item.selected for matching jurisdiction IDs
        this.$scope.organizations.forEach(item => {
          // console.log(item);
          item.selected = jurisdictionIds.includes(item.jurisdiction_id);
        });

        // Log to verify the updated organizations
        console.log(this.$scope.organizations);
      })
      .catch(err => {
        console.log(err);
      });

    // Fetch the user's sponsors
    this.fetch.getAllItems(`api/data/users/get-users-sponsors/${data.id}`)
      .then(response => {
        console.log('User sponsors:', response.data);

        // Extract sponsor IDs from the response (array of objects with sponsor_id)
        const sponsorIds = response.data.map(item => item.sponsor_id);

        // Update $scope.sponsors to set item.selected for matching sponsor IDs
        this.$scope.sponsors.forEach(item => {
          item.selected = sponsorIds.includes(item.sponsor_id);
        });

        console.log('Updated sponsors:', this.$scope.sponsors);
      })
      .catch(err => {
        console.log('Error fetching user sponsors:', err);
      });
  }


  updatePModal(id) {
    console.log(id);
    this.$scope.updateUserP.id = id;
  }

  deleteModal(id) {
    console.log(id);
    this.$scope.delUser.id = id;
  }

  /**
   * Updates a single user
   * Service: userService (app/components/services/users)
   * @param {*} id (id of user to be updated)
   */
  updateUser(id) {
    var adminBaseURL = this.baseConfigService.getAdminBaseURL();
    console.log(this.$scope.updateUser)
    var updateData = this.$scope.updateUser;
    this.$scope.saving = true;

    this.$http
      .post(`${adminBaseURL}/users/update`, updateData)
      .then((responseReport) => {
        console.log(responseReport);
        this.$scope.updateUser = {};
        // this.getAllUsers();
        $('#updateUsersModal').modal('toggle');
        this.$scope.saving = false;
      })
      .catch((err) => {
        console.log(err);
        this.$scope.saving = false;
        if (err.response === 403) {
          this.$state.go('/login');
        }
      });
  }

  /**
 * Updates a single user
 * Service: userService (app/components/services/users)
 * @param {*} id (id of user to be updated)
 */
  updateUserPwd() {
    this.$scope.saving = true;
    var adminBaseURL = this.baseConfigService.getAdminBaseURL();
    console.log(this.$scope.updateUserP)
    var updateData = {
      uid: this.$scope.updateUserP.id,
      newPassword: this.$scope.updateUserP.newPassword
    };

    this.$http
      .post(`${adminBaseURL}/users/update-pwd`, updateData)
      .then((responseReport) => {
        console.log(responseReport);
        this.$scope.updateUserP = {};
        this.$scope.saving = false;
        // this.getAllUsers();
        $('#updatePasswordModal').modal('toggle');
      })
      .catch((err) => {
        console.log(err);
        if (err.response === 403) {
          this.$state.go('/login');
        }
      });
  }

  /**
   * Delete a user
   */
  deleteUser() {
    var adminBaseURL = this.baseConfigService.getAdminBaseURL();
    var id = this.$scope.delUser.id;
  
    this.$http
      .delete(`${adminBaseURL}/users/delete-user/${id}`)
      .then((response) => {
        // Remove user from the table
        this.$scope.rowCollection = this.$scope.rowCollection.filter(user => user.id !== id);
        
        // Close the modal
        $('#deleteUserModal').modal('hide');
        
        // Clear the deleted user data
        this.$scope.delUser = {};
        
        // Show success message
        this.$scope.successMessage = 'User successfully deleted';
        
        // Ensure UI updates
        if (!this.$scope.$$phase) {
          this.$scope.$apply();
        }
      })
      .catch((err) => {
        console.error('Error deleting user:', err);
        if (err.status === 403) {
          this.$state.go('login');
        } else {
          this.$scope.errorMessage = 'Failed to delete user';
        }
      });
  }

  /**
   * Create a new user
   */
  createUser() {
    var adminBaseURL = this.baseConfigService.getAdminBaseURL();
    var newUserData = this.$scope.newUser; // Assuming this contains the user's details
    this.$scope.saving = true;
    this.$http
      .post(`${adminBaseURL}/users/create-user`, newUserData)
      .then((responseReport) => {
        console.log(responseReport);
        this.$scope.saving = false;
        this.$scope.newUser = {}; // Clear the new user form
        // Optionally refresh the user list
        this.$scope.rowCollection.push(newUserData)
        this.getAllUsers();
        $('#createUserModal').modal('toggle'); // Close the modal
      })
      .catch((err) => {
        console.log(err);
       
        this.$scope.saving = false;
        if (err.response && err.response.status === 403) {
          this.$state.go('/login'); // Redirect to login if unauthorized
        } else {
          // Handle other errors (e.g., display an error message)
          alert('An error occurred while creating the user.');
        }
      });
  }

  resetSearch() {
    console.log("resetting");
    // Clear search fields in the scope
    this.$scope.search = ''; // Assuming you have a text search field
    this.$scope.active = ''; // Reset the select bound to `st-search`
    this.$scope.role = ''; // Reset the select bound to `st-search`

    // Refresh the table to reflect the cleared search
    this.getAllUsers(); // Optionally call this if you want to refresh the displayed data
  }


}

export default angular.module('appApp.manageusers', [uiRouter])
  .config(routes)
  .component('manageusers', {
    template: require('./manageusers.html'),
    controller: ManageusersComponent,
    controllerAs: 'manageusersCtrl'
  })
  .directive("stFilteredCollection", function () {
    return {
      require: "^stTable",
      link: function (scope, element, attr, ctrl) {
        scope.$watch(ctrl.getFilteredCollection, function (val) {
          scope.filteredCollection = val;
          scope.currentPage = 0; // Current page number
          scope.pageSize = 10;   // Number of records per page
          scope.numberOfPages = function() {
              return Math.ceil(scope.filteredCollection.length / scope.pageSize);
          };
        });
      },
    };
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/admin/manageusers/manageusers.component.js